.card {
  text-align: center;
  padding: 44px 20px;
  border-radius: var(--radius-lg);
  background: var(--color-bg-elevated);
  border: 1px solid var(--color-border-default);
  position: relative;
  overflow: hidden;
}

.accentLine {
  position: absolute;
  top: 0;
  left: 20%;
  right: 20%;
  height: 2px;
  background: var(--accent-gradient);
}

.value {
  font-family: var(--font-heading);
  font-weight: 800;
  font-size: clamp(36px, 4vw, 52px);
  color: var(--color-text-primary);
  line-height: 1;
}

.label {
  font-family: var(--font-body);
  font-size: 11px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--color-text-muted);
  margin-top: 14px;
}

@media (max-width: 768px) {
  .card {
    padding: 28px 16px;
  }
}
